import React from 'react';
import { useTranslation } from 'react-i18next';
import EyeClose from '../../../assets/icons/iconEyeClose.svg';
import EyeOpen from '../../../assets/icons/iconEyeOpen.svg';

interface ReadingStats {
  read_count: number;
  high_score: number;
  last_score: number;
  average_score?: number;
}

interface SectionStatisticsProps {
  readingStats?: ReadingStats | null;
  byHeartStats?: ReadingStats | null;
  showAverageScore?: boolean;
}

const SectionStatistics: React.FC<SectionStatisticsProps> = ({
  readingStats,
  byHeartStats,
  showAverageScore = false
}) => {
  const { t } = useTranslation();
  
  // console.log('📊 SectionStatistics נטען עם נתונים:', {
  //   readingStats,
  //   byHeartStats,
  //   hasReadingData: readingStats && readingStats.read_count > 0,
  //   hasByHeartData: byHeartStats && byHeartStats.read_count > 0
  // });

  return (
    <div className="stats-container">
      {readingStats && readingStats.read_count > 0 && (
        <div className="stats in_writing">
          <img src={EyeOpen} alt={t('eyeOpen')} />
          <div className="scores">
            <h5>{t('numberOfReadings')}:</h5>
            <h5 className="value">{readingStats.read_count}</h5>
            <label>{t('highScore')}:</label>
            <div className="value">{readingStats.high_score}</div>
            <label>{t('lastScore')}:</label>
            <div className="value">{readingStats.last_score}</div>
            {showAverageScore && readingStats.average_score !== undefined && (
              <>
                <label>{t('averageScore')}:</label>
                <div className="value">{readingStats.average_score}</div>
              </>
            )}
          </div>
        </div>
      )}
      {byHeartStats && byHeartStats.read_count > 0 && (
        <div className="stats by_heart">
          <img src={EyeClose} alt={t('eyeClose')} />
          <div className="scores">
            <h5>{t('Recitation')}:</h5>
            <h5 className="value">
              {Number(byHeartStats.read_count) || t('none')}
            </h5>
            <label>{t('highScore')}:</label>
            <div className="value">{byHeartStats.high_score}</div>
            <label>{t('lastScore')}:</label>
            <div className="value">{byHeartStats.last_score}</div>
            {showAverageScore && byHeartStats.average_score !== undefined && (
              <>
                <label>{t('averageScore')}:</label>
                <div className="value">{byHeartStats.average_score}</div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionStatistics; 